<template #default>
  <div class="container-fluid p-0 m-0">
    <div class="row m-0 pt-5 bg-WeissTransparent justifyCenter">
      <div class="col-12 col-md-8 m-0 p-0 text-Rot-Schatten text-center">
        <h1 v-if="sprachID === 0">Mitgliederlisten und Vereinsanweisungen</h1>
        <h1 v-if="sprachID === 1">Member lists and club instructions</h1>
      </div>
    </div>


    <div class="row m-0 p-0 bg-WeissTransparent justifyCenter text-center">
      <div class="col-12 col-md-6 m-0 pt-5">
        <p v-if="sprachID === 0">Mitgliederlisten</p>
        <p v-if="sprachID === 1">member lists</p>
        <ul class="noDeko">                 
          <li class="borderRund"
            @click="openPDF('Vuepdf/mitgliederliste.pdf')">
            <span class="bold" v-if="sprachID === 0">Mitgliederliste</span>
            <span class="bold" v-if="sprachID === 1">member list</span>
          </li>                
          <li class="borderRund"
            @click="openPDF('Vuepdf/neueMitgliedsnummern.pdf')">
            <span class="bold" v-if="sprachID === 0">neue Mitgliedsnummern</span>
            <span class="bold" v-if="sprachID === 1">new membership numbers</span>
          </li>
          <p v-if="sprachID === 0" class="pt-5">
         Unterlagen / Verzeichnisse
        </p>     
          <p v-if="sprachID === 1">
        documents / directories
        </p>           
         
          
          <li class="borderRund"
            @click="openPDF('Vuepdf/benutzerordnung.pdf')">
            <span class="bold" v-if="sprachID === 0">Benutzerordnung</span>
            <span class="bold" v-if="sprachID === 1">User Rules</span>
          </li>
          <li class="borderRund"
            @click="openPDF('Vuepdf/auslagenrichtlinie.pdf')">
            <span class="bold" v-if="sprachID === 0">Auslagenrichtlinie</span>
            <span class="bold" v-if="sprachID === 1">Expenses Policy</span>
          </li>
        </ul>
      
      </div>
    </div>

  </div>

  
</template>

<script>
import { openModal } from "jenesius-vue-modal";
import modalPDF from "../components/ModalPDF.vue";
import modalBestellung from "../components/ModalBestellung.vue";

export default {
  name: "Loseblatt",

  data() {
    return {
      newSite: null,
    };
  },
  components: {},
  methods: {
    openPDF(pdf) {
      const props = { pdf: pdf };
      openModal(modalPDF, props);
    },
    openBestellung() {
      openModal(modalBestellung);
    },
  },
  computed: {
    sprachID() {
      let sprachID = this.$store.getters.getSprachID;
      return sprachID;
    },
  },
};
</script>

<style scoped></style>
